import Errors from './app-wrapper-errors.js'
import eventBus from '@researchmetrics/event-bus'

const PROMISE_TIMEOUT_DURATION = 1000
const unexpectedError = {
  name: Errors.ERROR_UNEXPECTED,
  message:
    'Unexpected error. Application wrapper application did not handle the request.'
}
const operationFailedError = {
  name: Errors.ERROR_WRAPPER_OPERATION_FAILED,
  message:
    'Application wrapper handled the request but was unable to complete it.'
}
const operationStatus = {
  success: 'success',
  fail: 'fail'
}

export default {
  operationStatus: operationStatus,
  unexpectedError: unexpectedError,
  PROMISE_TIMEOUT_DURATION: PROMISE_TIMEOUT_DURATION,
  promisePublishHandle: function(
    eventName,
    eventParameters,
    duration,
    expectsData
  ) {
    const timeoutDuration =
      typeof duration === 'undefined' ? PROMISE_TIMEOUT_DURATION : duration

    expectsData = !!expectsData
    return new Promise(function(resolve, reject) {
      const timeoutID = setTimeout(function() {
        reject(unexpectedError)
      }, timeoutDuration)

      eventBus.publish(
        eventName,
        eventParameters,
        undefined,
        callbackMessage => {
          // Disable timout counter
          clearTimeout(timeoutID)

          if (expectsData && typeof callbackMessage !== 'undefined') {
            resolve(callbackMessage)
          } else {
            if (callbackMessage === operationStatus.success) {
              resolve(operationStatus.success)
            } else {
              reject(operationFailedError)
            }
          }
        }
      )
    })
  }
}
